<template>
    <div class="flex flex-col items-center">
        A Generic Choose-One Question

        <div class="flex my-4">
            <button class="mx-2" @click="answer('a')">
                Choice A
            </button>

            <button class="mx-2" @click="answer('b')">
                Choice B
            </button>

            <button class="mx-2" @click="answer('c')">
                Choice C
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {},
    },

    methods: {
        answer(value) {
            this.$emit('answered', value);
        },
    },
}
</script>
